import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLetterNotification } from '../contexts/LetterNotificationContext';
import './MailNotification.css';

function MailNotification() {
  const { letterNotification, isVisible, dismissNotification } = useLetterNotification();
  const location = useLocation();
  const navigate = useNavigate();

  // Only show on home page
  if (location.pathname !== '/home') {
    return null;
  }

  if (!isVisible || !letterNotification) {
    return null;
  }

  const handleDismiss = (e) => {
    e.stopPropagation();
    dismissNotification();
  };

  const handleMailClick = () => {
    dismissNotification();
    navigate('/letters');
  };

  return (
    <div className="mail-notification-container">
      <div className="mail-notification" onClick={handleMailClick} style={{ cursor: 'pointer' }}>
        {/* Envelope with wax seal */}
        <div className="envelope-wrapper">
          <div className="envelope">
            <div className="envelope-body"></div>
            <div className="envelope-flap"></div>
            <div className="wax-seal"></div>
          </div>
          {/* Floating hearts around envelope */}
          <div className="floating-heart heart-1"></div>
          <div className="floating-heart heart-2"></div>
          <div className="floating-heart heart-3"></div>
        </div>

        {/* Speech bubble */}
        <div className="mail-speech-bubble">
          <p className="mail-bubble-text">
            {letterNotification.notificationType === 'nowReadable'
              ? `A letter from ${letterNotification.author} can now be opened!`
              : letterNotification.unreadCount === 1
                ? `${letterNotification.author} sent you a letter!`
                : `You have ${letterNotification.unreadCount} unread letters!`
            }
          </p>
          <div className="mail-bubble-tail"></div>
        </div>

        {/* Dismiss button */}
        <button
          className="mail-dismiss-button"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default MailNotification;
